// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3JzeM","description":"PatientConsentPreview_description__PY-n0"};